
import "./heroSectionStyle.css"
import React, { useContext } from "react";
import HeroSectionItem from "./heroSectionItem/heroSectionItem";
import { SelectedLanguageContext } from "../../../../contexts/siteContentsContext";

export default function HeroSection() {
    const { selectedLanguage } = useContext(SelectedLanguageContext);
    let catchPhrase = "";
    if (selectedLanguage.name ==='en-us') catchPhrase = "/photos/heroSection/catchyPhrase_EN.png";
    else if (selectedLanguage.name ==='pt-br') catchPhrase = "/photos/heroSection/catchyPhrase_PT-BR.png";

    return (
        <section className="hero-section__container">
            <img className="hero-section__background" src="/photos/hero-section-background.jpg" alt="" />

            <div className="hero-section__wrapper">
                <HeroSectionItem catchPhrase={catchPhrase} photo={"/photos/LOGOBRLABSsemfundo.png"} url={"/aboutUs"} />
            </div>
        </section>
    );
}
